import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from './../../../../../../src/environments/environment';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AdvConfigService {

  advConfig$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  get() {
    var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    // this.http.get("https://advdes15/Advice.Config.Rest/api/v1.0/GetAdvConfig/Get/Firmas_Poderes/" + environment.empresa, { headers: headers }).subscribe({
    this.http.get("http://" + window.location.hostname + "/Advice.Config.Rest/api/v1.0/GetAdvConfig/Get/Firmas_Poderes/" + environment.empresa, { headers: headers }).subscribe({
      //this.http.get("https://" + window.location.hostname + "/advconfigapi/Get/Firmas_Poderes/" + environment.empresa, { headers: headers }).subscribe({
      next: (data: any) => {
        environment.advCorpLoginApi = data.advCorpLoginApi;
        environment.advFirmasWebApi = data.advFirmasWebApi;
        environment.AdvFirmasWebApiCertificate = data.advFirmasWebApiCertificate;
        environment.versao = data.versaoApi;
        environment.logo = data.logoCliente;
        this.advConfig$.next(data);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 500) {
          Swal.fire({
            'width': 500,
            'title': 'Oops...',
            'text': error.error.detail,
            'icon': 'error'
          });
        } else {
          Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
        }
      }
    }).add(() => {
      this.advConfig$.unsubscribe(),
        this.advConfig$ = new BehaviorSubject(null);
    });
    // }

    // get() {
    //       environment.advCorpLoginApi = "http://advdes19/Advice.Corp.Rest";
    //       environment.advFirmasWebApi = "http://advdes19/FP/Rest";
    //       environment.AdvFirmasWebApiCertificate = "http://advdes19/FP/Rest.Certificate/";
    //       environment.versao = "v1.0";
    //       environment.logo = ""

    //       this.advConfig$.next(environment);
    // }
  }
}